export default function AppImage({
  src,
  alt = "",
  width,
  height,
  fill,
  className,
  priority,
  sizes,
  onLoadingComplete,
  onError,
  style,
  ...rest
}) {
  const resolvedStyle = fill
    ? { position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover", ...style }
    : { width, height, ...style };

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      style={resolvedStyle}
      loading={priority ? "eager" : "lazy"}
      fetchpriority={priority ? "high" : undefined}
      decoding={priority ? "sync" : "async"}
      sizes={sizes}
      onLoad={(event) => onLoadingComplete?.(event)}
      onError={onError}
      width={!fill ? width : undefined}
      height={!fill ? height : undefined}
      {...rest}
    />
  );
}
